import { FC } from 'react';

import { Button, DangerZone } from '../../../ui';

type RemovePaynowSectionProps = {
  saving: boolean;
  onRemove: () => void;
};

/** The destructive account action, set apart from Save. */
const RemovePaynowSection: FC<RemovePaynowSectionProps> = ({ saving, onRemove }) => (
  <DangerZone
    className="paymentDanger"
    title="Remove PayNow"
    description="The customer display will stop showing a payment code."
    action={
      <Button variant="destructive" onClick={onRemove} disabled={saving}>
        Remove PayNow
      </Button>
    }
  />
);

export default RemovePaynowSection;
